import { render, staticRenderFns } from "./HomeFeed.vue?vue&type=template&id=4b16b5eb&scoped=true&"
import script from "./HomeFeed.vue?vue&type=script&lang=js&"
export * from "./HomeFeed.vue?vue&type=script&lang=js&"
import style0 from "./HomeFeed.vue?vue&type=style&index=0&id=4b16b5eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b16b5eb",
  null
  
)

export default component.exports